import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class GroupEditService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	// Listar listUser
	getGroupDetails(token, idGroup) {

		return this.http
				.get(this.apiUrl + "groups/v1/getcodgroups/" + idGroup, JSON.parse(localStorage.getItem('yara.connectionHeader')))
				.map((res: Response) => res.json()).catch(e => {
					if (e.status === 401) {
						return Observable.throw('Unauthorized');
					}
				});
 	}

 	// Listar Permissões
	 getOtherPermissions(token) {

	 	return this.http
	 		.get(this.apiUrl + "permissions/v1/getpermissions?$orderby=Processo,Descricao&$active eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
	 		.map((res: Response) => res.json()).catch(e => {
	 			if (e.status === 401) {
	 				return Observable.throw('Unauthorized');
	 			}
	 		});
	 }

 	// Salvar Edição do Usuário
 	saveGroup(token, editGroup: any){

 		return this.http
 			.put(this.apiUrl + "groups/v1/updategroups", editGroup, JSON.parse(localStorage.getItem('yara.connectionHeader')))
 			.map((res: Response) => res.json())
 			.catch(e => {
 				if (e.status === 401) {
 					return Observable.throw('Unauthorized');
 				}
 			});
 	}

}



// WEBPACK FOOTER //
// ./src/app/group/service/group-edit/group-edit.service.ts